import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface DoaRangeFormValue {
  businessUnit: string;
  rangeType: 'existing' | 'new';
  rangeLevel: number;
  range1: string;
  range2: string;
}

/**
 * "DOA - Range Level - New" entry form shown on the DOA Range Level tab in
 * place of the generic refine/filter panel. The table below it stays the
 * shared catalog table; Save emits the form value so the parent can stage the
 * row through the normal catalog save flow. Styled by
 * domain-catalogs.component.scss (encapsulation: None on the parent).
 */
@Component({
  selector: 'app-catalog-doa-range-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './catalog-doa-range-form.component.html',
})
export class CatalogDoaRangeFormComponent {
  @Input() businessUnitOptions: string[] = [];
  @Input() rangeLevelOptions: number[] = [1, 2, 3, 4, 5, 6];
  @Input() recordCount = 0;
  @Output() save = new EventEmitter<DoaRangeFormValue>();
  @Output() formReset = new EventEmitter<void>();

  @Input() set editValue(value: DoaRangeFormValue | null) {
    if (value) this.form = { ...value };
  }

  form: DoaRangeFormValue = {
    businessUnit: '',
    rangeType: 'existing',
    rangeLevel: 1,
    range1: '',
    range2: '',
  };

  @Input() set defaultBusinessUnit(value: string | null | undefined) {
    if (value && !this.form.businessUnit) this.form.businessUnit = value;
  }

  get canSave(): boolean {
    return !!this.form.businessUnit && !!this.form.range1.trim() && !!this.form.range2.trim();
  }

  submit(): void {
    if (!this.canSave) return;
    this.save.emit({ ...this.form });
    this.reset();
  }

  /** Clears the form back to its default values and returns to add-new mode. */
  resetForm(): void {
    this.reset();
    this.formReset.emit();
  }

  private reset(): void {
    this.form = {
      businessUnit: '',
      rangeType: 'existing',
      rangeLevel: 1,
      range1: '',
      range2: '',
    };
  }
}
